import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import CountryFlag from 'react-country-flag'
import { useSelector } from 'react-redux'

import { translate } from '../../helpers/stringHelpers'

// components
import ListingMediaImages from '../listingMediaImages'
import Badge from '../badge'
import ContactSellerModal from '../contactSellerModal'

const isSameLength = (a, b) => a.length === b.length

const getLotNumberString = (listingType, isMarketplace = false) => {
  if (isMarketplace) return 'ItemCodes_MARKETPLACE_DISPLAY_VALUE'
  if (listingType === 'listing') return 'ItemCodes_LISTING_DISPLAY_VALUE'
  return 'ItemCodes_LOT_DISPLAY_VALUE'
}

export const ListingMedia = (props) => {
  const { listingUuid, query } = props
  const [isContactSellerModalVisible, setContactSellerModalVisibility] = useState(false)
  const listings = useSelector(state => state.lots.listings, isSameLength)
  const attachments = useSelector(state => state.attachments.attachments, isSameLength)
  const listing = useSelector(state => state.lots.listings[listingUuid])
  const auctionUuid = listing?.auctionUuid
  const images = useSelector(state => listing?.images
    ?.map(imageUuid => state.attachments.attachments?.[imageUuid])
    ?.filter(image => !!image) || [], isSameLength)
  const configurationKey = listing?.isMarketplace ? 'marketplace' : auctionUuid
  const isItemLocationVisible = useSelector(state => state.auctions.configurations[configurationKey]?.showItemLocation)

  if (!listing || !auctionUuid) return null
  const auctionPath = listing.isMarketplace ? '/marketplace' : `/auctions/${listing.auctionUuid}`
  const listingLink = `${auctionPath}/listings/${listingUuid}${query}`
  const isGroup = listing.groupedItems && listing.groupedItems.length > 0
  const groupedItems = listing.groupedItems
  const groupImages = groupedItems
    ?.map(listingUuid => listings[listingUuid])
    ?.sort((a, b) => a.auctionIndex - b.auctionIndex)
    ?.reduce((acc, listing) => {
      acc.push(attachments[listing.images[0]])
      return acc
    }, [])

  return (
    <div className={`lot__media
      ${images.length || groupedItems?.length
        ? ''
        : ' lot__media--empty'
    }
    `}
    key='listing-info__gallery'
    >
      {listing.lotNumber
        ? (
          <Badge color='primary' className='lot__number'>
            {isItemLocationVisible && listing.countryCode
              ? (
                <CountryFlag
                  aria-label={listing.countryCode}
                  countryCode={listing.countryCode.replace('UK', 'GB')}
                  className='lot__country-flag'
                  svg
                  title={listing.countryCode}
                />
                )
              : null}
            {translate(getLotNumberString(listing.type, listing.isMarketplace))} {listing.isMarketplace ? listing.id : listing.lotNumber}
          </Badge>
          )
        : null}
      {listing.contactSeller
        ? (
        <Badge
          color='secondary' className='lot__contact clickable' onClick={() => setContactSellerModalVisibility(true)}
        >
          <FontAwesomeIcon icon={faEnvelope} /> {translate('JspPublicCodes_JSP_BIDDING_CONTACT_SELLER')}
        </Badge>
          )
        : null}
      <ContactSellerModal
        isOpen={isContactSellerModalVisible}
        listingUuid={listingUuid}
        onClose={() => setContactSellerModalVisibility(false)}
      />
      <ListingMediaImages images={isGroup ? groupImages : images} listingLink={listingLink} listing={listing} listingUuid={listingUuid} />
    </div>
  )
}

ListingMedia.propTypes = {
  currentLanguageCode: PropTypes.string, // eslint-disable-line react/no-unused-prop-types -- memo comparator uses this; not read in body
  listingUuid: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired
}

const isEqual = (a, b) => a.listingUuid === b.listingUuid &&
  a.query === b.query &&
  a.currentLanguageCode === b.currentLanguageCode

export default React.memo(ListingMedia, isEqual)
